import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const GenerationDisabledTooltip = ({
  children,
  isGenerativeAiEnabled
}) => {
  const settingsLink = `/ai-settings/${PortalIdParser.get()}?source=post-narration`;
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: Boolean(isGenerativeAiEnabled),
    title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "audioNarration.panel.generationDisabledTooltip_jsx",
      elements: {
        UILink
      },
      options: {
        settingsLink
      }
    }),
    maxInlineSize: "250px",
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
};
export default GenerationDisabledTooltip;